import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Logo from '../../components/Svg/ActionButtonLogo';
import PublisherLogo from '../../components/Widget/PublisherLogo';
import PartnerLogo from '../../components/Widget/PartnerLogo';
import { SponsoredTag } from '../../components/Widget/SponsoredTag';

import { copyFor } from '../../copy/copy';

import {
    setOverlayVisible,
    setOverlayPublisherVisible,
    setOverlayPartnerVisible
} from './actions';

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 24px;
`;

const LogoWrapper = styled.div`
    &.hide {
        display: none;
    }
`;

const WidgetHeader = props => (
    <Header>
        <Logo onClick={() => props.setOverlayVisible(true)} />
        <LogoWrapper>
            {props.partnerLogo && props.isPartnerLogoVisible && (
                <PartnerLogo
                    logoUrl={props.partnerLogo}
                    onClick={() => props.setOverlayPartnerVisible(true)}
                />
            )}
            {props.isSponsored && (
                <SponsoredTag
                    isVisual={props.isVisual}
                    sponsoredText={props.sponsoredText}
                />
            )}
            {props.publisherLogoUrl && !props.isPartnerLogoVisible && (
                <PublisherLogo
                    logoUrl={props.publisherLogoUrl}
                    onClick={() => props.setOverlayPublisherVisible(true)}
                />
            )}
        </LogoWrapper>
    </Header>
);

WidgetHeader.propTypes = {
    isPartnerLogoVisible: PropTypes.bool.isRequired,
    isSponsored: PropTypes.bool,
    isVisual: PropTypes.bool,
    sponsoredText: PropTypes.string,
    partnerLogo: PropTypes.string,
    publisherLogoUrl: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    setOverlayPublisherVisible: PropTypes.func.isRequired,
    setOverlayVisible: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const currentCard = state.widget.cards.find(
            c => c.id === state.widget.activeAction.widgetCardId
        );

        return {
            isPartnerLogoVisible: currentCard.logoSource === 1,
            isSponsored: state.widget.isSponsored,
            isVisual: state.widget.activeAction.isVisual,
            sponsoredText:
                state.widget.sponsoredText || copyFor('miscellaneous', 'sponsored'),
            partnerLogo: (state.widget.selectedPartner || {}).logoUrl || '',
            publisherLogoUrl: state.widget.publisherLogoUrl
        };
    },
    { setOverlayVisible, setOverlayPublisherVisible, setOverlayPartnerVisible }
)(WidgetHeader);
